// Import dependencies
import './capture.js';
import { RMS } from './rms.js';
import { initDroid } from './droid.js';

window.initDroid = initDroid;
window.RMS = RMS;

// Add this helper class at the top of your script
class AnimationQueue {
    constructor(droidControls) {
        this.queue = Promise.resolve();
        this.droid = droidControls;
    }

    wait(ms) {
        this.queue = this.queue.then(() => new Promise(resolve => setTimeout(resolve, ms)));
        return this;
    }

    text(message, duration = 1.5) {
        this.queue = this.queue.then(() => {
            this.droid.addText(message, duration);
            return new Promise(resolve => setTimeout(resolve, duration * 1000));
        });
        return this;
    }

    eye(color, animation, duration) {
        this.queue = this.queue.then(() => {
            this.droid.stopEyeAnimation();
            if (color) this.droid.setEyeColor(...color);
            if (animation) this.droid[animation](duration);
            // Resolve immediately - animation runs in background via requestAnimationFrame
            return Promise.resolve();
        });
        return this;
    }

    button(text, onClick) {
        this.queue = this.queue.then(() => new Promise(resolve => {
                    // Create and show the button
                    this.droid.addButton(text, async (e) => {
                        await onClick(e);
                    });
                    // Resolve immediately after creating the button, don't wait for click
                    resolve();
                }));
        return this;
    }

    input(submitBtnText, id, onSubmit, defaultValue = null, placeholder = '') {
        let resolveCurrentPromise;
                this.queue = this.queue.then(() => new Promise(resolve => {
                    resolveCurrentPromise = resolve;  // Store the resolve function
                    this.droid.addInput(submitBtnText, id, async (value) => {
                        if(await onSubmit(value)) {
                            resolve();
                        }
                    }, defaultValue, placeholder);
                    // Store the resolve function on the dialogue box for cleanup
                    this.droid.setCurrentInputResolve(resolveCurrentPromise);
                }));
                return this;
            }

            clear(delay = false) {
                // Reset the queue to a resolved promise
                
                
                if(delay) {
                    this.queue = this.queue.then(() => {
                        this.droid.clearDialogue();
                        return Promise.resolve();
                    });
                } else {
                    this.queue = Promise.resolve();
                    this.droid.clearDialogue();
                }
                return this;
            }

            action(action) {
                this.queue = this.queue.then(() => {
                    action();
                    return Promise.resolve();
                });
                return this;
            }

            copyInput(text, id) {
                this.queue = this.queue.then(() => {
                    this.droid.addCopyableInput(text, id);
                    return Promise.resolve();
                });
                return this;
            }
        }

window.AnimationQueue = AnimationQueue;

